import React from "react";

export const WhiteFacebookLogo = () => (
    <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.79777 16.3197V8.15888H8.05047L8.349 5.34663H5.79777L5.80159 3.93907C5.80159 3.20559 5.87128 2.81257 6.92476 2.81257H8.33305V0H6.08003C3.37379 0 2.42127 1.36425 2.42127 3.65848V5.34694H0.734375V8.1592H2.42127V16.3197H5.79777Z"
            fill="white"
        />
    </svg>
);
